import { PageMeta } from "src/components";
import { appConfig } from "src/config";
import { LEGAL_DOCUMENTS } from "src/constants/constants";
import { useTranslate } from "src/i18n";
import { DocumentViewer } from "src/widgets/DocumentViewer/DocumentViewer";

export const OfferPage = () => {
  const { t } = useTranslate();

  const title = t("offer.title", "Публичная оферта");
  const pageTitle = `${title} — ${appConfig.displayName}`;
  const description = t(
    "offer.meta.description",
    "Публичная оферта сервиса {displayName}. Условия предоставления услуг.",
    { displayName: appConfig.displayName },
  );

  return (
    <>
      <PageMeta title={pageTitle} description={description} path="/offer" />
      <DocumentViewer
        title={title}
        pdfUrl={LEGAL_DOCUMENTS.OFFER}
        documentTitle={title}
      />
    </>
  );
};
